export const formatToPrecision = (value: number, precision: number): number => {
    if (isNaN(value)) return NaN;
    return parseFloat(value.toPrecision(precision));
};
